import { SignUpFormFields } from 'config/sign_up_form';

import SignUpFormValidator from './SignUpFormValidator';

const validateSignUpForm = (signUpForm) => {
  const validator = SignUpFormValidator(signUpForm);
  const fields = Object.keys(SignUpFormFields);

  const errors = {};
  for (const field of fields) {
    const errorMessage = validator[field](signUpForm[field]);
    if (errorMessage) errors[field] = errorMessage;
  }

  if (!Object.keys(errors).length) return null;
  return errors;
};

export default validateSignUpForm;
